<template>
  <parent-tabs :tabs="filterTabs()" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ShipmentSummaryParent',
  methods: {
    filterTabs () {
      return this.pageTabs.reduce((accu, i) => {
        if (i.can) accu.push(i)
        return accu
      }, [])
    }
  },
  computed: {
    ...mapGetters({
      can: 'can'
    }),
    pageTabs () {
      return [
        { id: 1, title: 'List', route: '/shipment-summary-list', can: this.can('api.view_lot') },
        { id: 2, title: 'Create', route: '/create-shipment-summary', can: this.can('api.add_lot') }
      ]
    }
  }
}
</script>
